import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/modern/utils";
import { SURFACE_ICON_BTN_CLS } from "@/react/components/entityViews/files/constants/surfaceChrome";

interface FileCollectionNavButtonsProps {
  filesCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void | Promise<void>;
  isLoadingMore?: boolean;
  variant?: "inline" | "overlay";
}

export const FileCollectionNavButtons = ({
  filesCount,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  isLoadingMore = false,
  variant = "inline",
}: FileCollectionNavButtonsProps) => {
  if (filesCount <= 1 && !hasNext) {
    return null;
  }

  if (variant === "overlay") {
    return (
      <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-between">
        <button
          type="button"
          className={cn(
            SURFACE_ICON_BTN_CLS,
            "pointer-events-auto inline-flex shrink-0 items-center justify-center shadow-md disabled:pointer-events-none disabled:opacity-40",
          )}
          onClick={onPrevious}
          disabled={!hasPrevious}
          aria-label="Previous file"
        >
          <ChevronLeft className="size-4" />
        </button>
        <button
          type="button"
          className={cn(
            SURFACE_ICON_BTN_CLS,
            "pointer-events-auto inline-flex shrink-0 items-center justify-center shadow-md disabled:pointer-events-none disabled:opacity-40",
          )}
          onClick={() => void onNext()}
          disabled={!hasNext || isLoadingMore}
          aria-label="Next file"
        >
          <ChevronRight className="size-4" />
        </button>
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        className={cn(
          SURFACE_ICON_BTN_CLS,
          "inline-flex items-center justify-center disabled:opacity-40",
        )}
        onClick={onPrevious}
        disabled={!hasPrevious}
        aria-label="Previous file"
      >
        <ChevronLeft className="size-4" />
      </button>
      <button
        type="button"
        className={cn(
          SURFACE_ICON_BTN_CLS,
          "inline-flex items-center justify-center disabled:opacity-40",
        )}
        onClick={() => void onNext()}
        disabled={!hasNext || isLoadingMore}
        aria-label="Next file"
      >
        <ChevronRight className="size-4" />
      </button>
    </>
  );
};
